import {
  setActiveBitrix,
  setDataBitrix,
  setErrorBitrix,
} from "../../../../store/slices/integrationSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

let userId = localStorage.getItem("@storage_User_Id");

export const initBitrix = (dataReq, setLoading, setIsConnected, setError) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/bitrix/create`,
        dataReq
      );

      if (data.code === 200) {
        setIsConnected(true);
      } else {
        setError("Ошибка инициализации Bitrix");
      }
    } catch (error) {
      if (!error.response) {
        setError("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        setError("Ошибка сервера. Попробуйте позже.");
      } else if (error.response.data?.message === "error: invalid api url") {
        setError("Неверный API URL, повторите попытку.");
      } else if (
        error.response.data?.message?.includes("TLS handshake timeout")
      ) {
        setError(
          "Произошла ошибка соединения с Bitrix. Повторите попытку позже."
        );
      }

      console.error("initBitrix error:", error);
    } finally {
      setLoading(false);
    }
  };
};

// Удаление интеграции
export const deleteIntegrationBitrix = (dataReq, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/bitrix/delete`,
        dataReq
      );
      if (data.code === 200) {
        dispatch(setActiveBitrix(null));
        localStorage.removeItem("dataActiveBitrix");
        dispatch(getIntegrationsBitrixList(dataReq.userId));
        navigate("/integration");
        setLoading(false);
      } else {
        setLoading(false);
        errorToast("Ошибка удаления интеграции");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("deleteIntegrationBitrix error:", error);
    }
  };
};

// Получение конкретной интеграции
export const getIntegrationBitrix = (
  userId,
  clientId,
  setLoading = () => {}
) => {
  return async (dispatch) => {
    dispatch(setErrorBitrix(false));
    setLoading(true);
    try {
      const { data } = await $authHost.get(
        `/integrations/bitrix?userId=${userId}&clientId=${clientId}`
      );
      if (data.code === 200) {
        setLoading(false);
        dispatch(
          setActiveBitrix({
            dataUser: data.bitrixUser,
            dataCategories: data.categories,
          })
        );
        console.log("data", data);
        localStorage.setItem(
          "activeBitrix",
          JSON.stringify({
            dataUser: data.bitrixUser,
            dataCategories: data.categories,
          })
        );
      } else {
        setLoading(false);
        errorToast("Не удалось получить интеграцию с Bitrix");
      }
    } catch (error) {
      dispatch(setErrorBitrix(true));
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("getIntegrationBitrix error:", error);
    }
  };
};

// Получение списка интеграций
export const getIntegrationsBitrixList = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/bitrix/list?userId=${userId}`
      );
      if (data.code === 200) {
        dispatch(setDataBitrix(data.bitrixUsers));
        localStorage.setItem("dataBitrix", JSON.stringify(data.bitrixUsers));
      } else {
        errorToast("Не удалось загрузить список интеграций Bitrix");
      }
      // console.log("getIntegrationsBitrixList", data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("getIntegrationsBitrixList error:", error);
    }
  };
};

// Обновление воронки
export const updateCategoryBitrix = (dataReq) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/bitrix/category`,
        dataReq
      );
      if (data.code === 200) {
        dispatch(getIntegrationsBitrixList(userId));
      } else {
        errorToast("Не удалось обновить категорию Bitrix");
      }
      // console.log("updateCategoryBitrix", data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("updateCategoryBitrix error:", error);
    }
  };
};

// Обновление этапа воронки
export const updateCategoryStageBitrix = (dataReq) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/bitrix/category-stage`,
        dataReq
      );
      if (data.code === 200) {
        // console.log("data updateCategoryStageBitrix", data);

        dispatch(getIntegrationsBitrixList(userId));
      } else {
        errorToast("Не удалось обновить этап воронки Bitrix");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (
          error.response.status === 400 &&
          error.response.data.message === "error: invalid UUID length: 0"
        ) {
          errorToast("Выберите ассистента");
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("updateCategoryStageBitrix error:", error);
    }
  };
};
